<template>
  <div class="collar">
    <!-- “collar”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeCompany="changeCompany"
      @changeChecked="changeChecked"
    ></sirui-search>
    <!-- collar -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="{ ...tokenInfo }"
    ></sirui-upload>
  </div>
</template>
<script>
  // import { mapState } from 'vuex';
  import API from '@/api/financeCenter/generalAccounting';
  import DataBaseAPI from '@/api/dataBase';
  import tableMixins from '@/common/mixins/table.js';
  import siruiUpload from '@/components/SiruiUpload';
  export default {
    name: 'queryVoucher',
    mixins: [tableMixins],
    components: {
      siruiUpload,
    },
    computed: {
      tokenInfo() {
        return {
          access_token: this.userInfo.userInfo.access_token,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          tenantCode: this.userInfo.userInfo.tenantCode,
        };
      },
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          //公司代码
          {
            prop: 'voucherCompanyCode',
            name: this.$t('glVoucher.column.voucherCompanyName'),
            type: 'select',
            options: this.companyList,
            changeMethod: 'changeCompany',
          },
          //模块
          {
            prop: 'applicationCode',
            name: this.$t('glVoucher.column.applicationCode'),
            type: 'select',
            options: this.applicationList,
            value: 'applicationCode',
            label: 'applicationName',
          },
          //凭证类型
          {
            prop: 'voucherType',
            name: this.$t('glVoucher.column.voucherType'),
            type: 'select',
            options: this.sapVoucherTypeList,
          },
          //凭证编号
          {
            type: 'input',
            prop: 'voucherNo',
            name: this.$t('glVoucher.column.voucherNo'),
            searchType: 'personnel',
          },
          //业务单据编号
          {
            type: 'input',
            name: this.$t('glVoucher.column.entityDataNo'),
            prop: 'entityDataNo',
          },
          // SAP凭证编号
          {
            prop: 'sapVoucherNo',
            name: this.$t('glVoucher.column.sapVoucherNo'),
            type: 'input',
          },
          //入账状态
          {
            prop: 'syncFlag',
            name: this.$t('glVoucher.column.syncFlag'),
            type: 'dict',
            dictType: 'VOUCHERSYNFLAG',
          },
          //期间
          {
            prop: 'calendarPeriod',
            name: this.$t('glVoucher.column.calendarPeriod'),
            type: 'select',
            options: this.ledgerPeriodList,
            value: 'calendarPeriod',
            label: 'calendarPeriod',
          },
          // 创建日期
          {
            prop: 'startGmtCreate',
            name: this.$t('glVoucher.column.gmtCreateBegin'),
            type: 'startDaterangePicker',
          },
          {
            prop: 'endGmtCreate',
            name: this.$t('glVoucher.column.gmtCreateEnd'),
            type: 'endDaterangePicker',
          },
          //本币合计金额 inputRange
          {
            prop: ['startAccountedVoucherAmount', 'endAccountedVoucherAmount'],
            name: this.$t('glVoucher.column.voucherLocalCurrencyStart'),
            max: 99999999999999.99,
            type: 'inputRange',
          },
          //原币合计金额
          {
            prop: ['startVoucherAmount', 'endVoucherAmount'],
            name: this.$t('glVoucher.column.voucherOriginalCoin'),
            max: 99999999999999.99,
            type: 'inputRange',
          },
          // 入账日期
          {
            prop: 'startPostDate',
            name: this.$t('glVoucher.column.postDateBegin'),
            type: 'startDaterangePicker',
          },
          {
            prop: 'endPostDate',
            name: this.$t('glVoucher.column.postDateEnd'),
            type: 'endDaterangePicker',
          },
          // 科目 要修改
          {
            prop: ['accountCodeStart', 'accountCodeEnd'],
            name: this.$t('glVoucher.column.accountCode'),
            max: 99999999999999,
            type: 'inputRange',
          },
          //本币金额
          {
            prop: ['accountedAmountStart', 'accountedAmountEnd'],
            name: this.$t('glVoucher.column.accountedAmount'),
            type: 'inputRange',
            max: 99999999999999.99,
          },
          //原币金额
          {
            prop: ['enteredAmountSatrt', 'enteredAmountEnd'],
            name: this.$t('glVoucher.column.enteredAmount'),
            type: 'inputRange',
            max: 99999999999999.99,
          },
          //现金流事务代码
          {
            prop: ['cashflowTransactionCodeStart', 'cashflowTransactionCodeEnd'],
            name: this.$t('glVoucher.column.cashflowTransactionCode'),
            type: 'inputRange',
            max: 99999999999999,
          },
          // 过账人
          {
            prop: 'postUserName',
            name: '过账人',
            type: 'input',
          },
          // 操作人
          {
            prop: 'createUserName',
            name: this.$t('glVoucher.column.createUserName'),
            type: 'input',
          },

          //部门
          /* {
          prop: "voucherDepartmentCode",
          name: this.$t("glVoucher.column.voucherDepartment"),
          type: "select",
          options: this.departmentList
        }, */
          //按凭证行明细展示 checkbox
          /*  {
          prop: "voucherFlag",
          name: this.$t("glVoucher.column.voucherFlag"),
          type: "checkbox",
          changeMethod: "changeChecked"
        } */
        ];
      },
      columnListDefault() {
        return [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left', show: true },
          {
            field: 'voucherCompanyCode',
            title: 'glVoucher.column.voucherCompanyCode',
            visible: true,
          }, //公司编码
          {
            field: 'voucherCompanyName',
            title: 'glVoucher.column.voucherCompanyName',
            visible: true,
          }, //公司名
          { field: 'ledgerCode', title: 'glVoucher.column.ledgerCode', visible: true }, //账套代码
          { field: 'applicationName', title: 'glVoucher.column.applicationCode', visible: true }, //模块名称，字典
          //{field: "voucherType",title: "glVoucher.column.voucherType",visible: true,dictType:'GLVOUCHERTYPE'},//凭证类型，字典
          { field: 'voucherNo', title: 'glVoucher.column.voucherNo', visible: true }, //凭证编号
          { field: 'entityDataNo', title: 'glVoucher.column.entityDataNo', visible: true }, //业务单据编号
          { field: 'postDate', title: 'glVoucher.column.postDate', visible: true }, //入账日期
          { field: 'calendarPeriod', title: 'glVoucher.column.calendarPeriod', visible: true }, //期间
          {
            field: 'voucherAmount',
            title: 'glVoucher.column.drVoucherAmount',
            visible: true,
            format: 'formatAmount',
          }, //原币借方金额合计
          {
            field: 'voucherAmount',
            title: 'glVoucher.column.crVoucherAmount',
            visible: true,
            format: 'formatAmount',
          }, //原币贷方金额合计
          {
            field: 'accountedVoucherAmount',
            title: 'glVoucher.column.drAccountedVoucherAmount',
            visible: true,
            format: 'formatAmount',
          }, //原币借方金额合计
          {
            field: 'accountedVoucherAmount',
            title: 'glVoucher.column.crAccountedVoucherAmount',
            visible: true,
            format: 'formatAmount',
          }, //原币贷方金额合计
          { field: 'currencyCode', title: 'glVoucher.column.currencyCode', visible: true }, //币种代码
          { field: 'exchangeRate', title: 'glVoucher.column.exchangeRate', visible: true }, //汇率
          {
            field: 'syncFlag',
            title: 'glVoucher.column.syncFlag',
            visible: true,
            dictType: 'VOUCHERSYNFLAG',
          }, //入账状态
          { field: 'postUserName', title: '过账人', visible: true }, //入账状态
          { field: 'createUserName', title: 'glVoucher.column.createUserName', visible: true }, //操作人
          { field: 'gmtCreate', title: 'glVoucher.column.gmtCreate', visible: true }, //记录创建时间
          // {field: "reverseDocNo",title: "glVoucher.column.reverseDocNo",visible: true},//冲销单据编号
          {
            field: 'reverseSapVoucherNo',
            title: 'glVoucher.column.reverseVoucherNo',
            visible: true,
          }, //冲销凭证编号
          { field: 'reverseDate', title: 'glVoucher.column.reverseDate', visible: true }, //冲销日期
          { field: 'sapVoucherNo', title: 'glVoucher.column.sapVoucherNo', visible: true }, //SAP凭证编号
          { field: 'summary', title: 'glVoucher.column.summaryList', visible: true }, //摘要
          //明细
          ...(this.query.voucherFlag
            ? [
                { field: 'accountCode', title: 'glVoucher.table.accountCode', visible: true }, //科目代码
                { field: 'accountDesc', title: 'glVoucher.table.accountDesc', visible: true }, //科目描述
                { field: 'enteredDrAmount', title: 'glVoucher.table.enteredAmount', visible: true }, //原币金额
                {
                  field: 'accountedDrAmount',
                  title: 'glVoucher.table.accountedAmount',
                  visible: true,
                }, //本币借方金额
                {
                  field: 'voucherDepartmentCode',
                  title: 'glVoucher.table.departmentCode',
                  visible: true,
                }, //部门代码
                {
                  field: 'voucherDepartmentName',
                  title: 'glVoucher.table.departmentName',
                  visible: true,
                }, //部门名称
                {
                  field: 'cashflowTransactionCode',
                  title: 'glVoucher.table.cashflowTransactionCode',
                  visible: true,
                }, //现金流量事务代码
                {
                  field: 'cashflowTransactionName',
                  title: 'glVoucher.table.cashflowTransactionName',
                  visible: true,
                }, //现金流量事务名称
              ]
            : []),
        ];
      },
    },
    data() {
      return {
        action: API.IMPORT,
        exportAction: API.EXPORT,
        sapVoucherTypeList: [],
        query: {
          voucherCompanyCode: '',
          applicationCode: '',
          voucherType: '',
          voucherNo: '',
          entityDataNo: '',
          sapVoucherNo: '',
          syncFlag: '',
          calendarPeriod: '',
          startGmtCreate: '',
          endGmtCreate: '',
          startAccountedVoucherAmount: '',
          endAccountedVoucherAmount: '',
          startVoucherAmount: '',
          endVoucherAmount: '',
          startPostDate: '',
          endPostDate: '',
          accountCodeStart: '',
          accountCodeEnd: '',
          accountedAmountStart: '',
          accountedAmountEnd: '',
          enteredAmountSatrt: '',
          enteredAmountEnd: '',
          cashflowTransactionCodeStart: '',
          cashflowTransactionCodeEnd: '',
          voucherDepartmentCode: '',
          voucherFlag: false,
          createUserName: '',
          postUserName: '',
        },
        companyList: [], // 公司代码
        departmentList: [],
        applicationList: [], // 模块
        ledgerPeriodList: [], //会计期间
      };
    },
    mounted() {
      this.getAeApplicationList();
      this.getCompany();
      this.getData();
      this.getButtonList();
      this.changeChecked();
    },
    methods: {
      resetBtnClick() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.changeChecked();
        this.getData();
      },
      getCompany() {
        this.$axios
          .get(DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.userInfo.tenantCode}`, {})
          .then((res) => {
            if (res.data.code == 0) {
              this.companyList = res.data.data;
            }
          });
      },
      getAeApplicationList() {
        this.$axios.post(DataBaseAPI.LIST_AE_APPLICATION, {}).then((res) => {
          if (res.data.code == 0) {
            this.applicationList = res.data.data;
          }
        });

        this.$baseRequest.getSapVouScherType().then((res) => {
          // 凭证类型
          this.sapVoucherTypeList = res.map((item) => {
            return {
              ...item,
              label: item.voucherTypeCode,
              value: item.voucherTypeCode,
            };
          });
        });
      },
      getFinanceLedgerPeriodList(ledgerCode) {
        this.$axios
          .post(DataBaseAPI.LIST_FINANCE_LEDGER_PERIOD, {
            periodStatusList: ['open', 'closed'],
            ledgerCode: ledgerCode,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.ledgerPeriodList = res.data.data;
            }
          });
      },
      // 获取列表数据
      getData() {
        console.log(this.query.voucherFlag);
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        let params = { ...this.query, pageNum, pageSize };
        if (params.startGmtCreate) params.startGmtCreate = params.startGmtCreate + ' 00:00:00';
        if (params.endGmtCreate) params.endGmtCreate = params.endGmtCreate + ' 23:59:59';
        this.load = true;
        this.$axios.post(API.VOUCHER_QUERY_PAGE, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //切换公司
      changeCompany(val) {
        this.departmentList = [];
        this.companyList.find((item) => {
          if (item.value === val.val) {
            this.initDepartment();
          }
        });
        //获取账套列表
        this.$baseRequest.getLedger(val.val).then((ledgerInfo) => {
          if (ledgerInfo[0]) {
            this.ledgerList = ledgerInfo;
            this.getFinanceLedgerPeriodList(this.ledgerList[0].ledgerCode);
          }
        });
      },
      //业务部门
      initDepartment() {
        this.$axios
          .post(DataBaseAPI.LIST_DEPARTMENT_API + '/' + this.query.voucherCompanyCode)
          .then((res) => {
            if (0 == res.data.code) {
              this.departmentList = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      changeChecked() {
        let arr = [];
        if (this.query.voucherFlag) {
          // this.columnListDefault
          arr = JSON.parse(JSON.stringify(this.columnListDefault));
        } else {
          arr = this.columnListDefault.filter((item) => {
            return item.show == true;
          });
        }
        this.columnListShow = arr;
      },
      // 按钮
      chooseClick(type) {
        if (type == 'add') {
          this.toPath('addVoucher', {});
        } else if (type == 'edit') {
          if (this.multipleSelection.length != 1) {
            return this.tips('onlyOneSelectData', 'error');
          }
          this.toPath('editVoucher', { id: this.multipleSelection[0].id });
        } else if (type == 'delete') {
          this.handleDel();
        } else if (type == 'export') {
          this.commonExport();
        } else if (type == 'bulkAccount') {
          this.batchSyncVoucher(API.BATCH_VOUCHER, {
            idList: this.multipleSelection.map((item) => item.id),
          });
        } else if (type == 'import') {
          this.handleImport();
        }
      },
      //批量上传
      handleImport() {
        this.$refs.SiruiUpload.openDialog(true);
      },
      // 删除
      handleDel() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected', 'error');
        }
        let canDelitems = [];
        this.multipleSelection.map((i) => {
          if (['1', 'F'].indexOf(i.syncFlag) != -1) {
            canDelitems.push(i);
          }
        });
        if (canDelitems.length == 0) {
          return this.tips('noCanDelSelectData', 'error');
        }
        let items = canDelitems.map((i) => i.id);
        let message = '';
        if (canDelitems.length !== this.multipleSelection.length) {
          message = this.$t('glVoucher.message.hasCannotDelTip');
        }
        this.$confirmAction(this.$t('confirm.delete'), message)
          .then(() => {
            this.del(items);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 删除
      del(ids) {
        this.$axios.post(API.VOUCHER_DEL, ids).then((res) => {
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      dblclickEvent(value) {
        // 列表双击
        this.toPath('detailVoucher', { id: value.row.id });
      },
      tips(info) {
        // 提示
        this.$message({
          showClose: true,
          message: this.$t(`glVoucher.message.${info}`),
          type: 'error',
        });
      },
      // 跳转路径
      toPath(name, query) {
        let path = {
          path: `/generalAccounting/${name}`,
          name: name,
          meta: { keepAlive: true },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
